import { Node } from 'slate';

export const getPlainText = (nodes: Node[]) => {
  return nodes.map((n) => Node.string(n)).join('\n');
};
